import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { PessoaTermoLGPDStatusBadgeModule } from '../status/badge';
import { PessoaTermoLGPDFileUploadModule } from '../file-upload';

import { PessoaTermoLGPDFormComponent } from './pessoa-termo-lgpd-form.component';


@NgModule({
    imports: [
        SharedModule,
        PessoaTermoLGPDStatusBadgeModule,
        PessoaTermoLGPDFileUploadModule
    ],
    declarations: [
        PessoaTermoLGPDFormComponent
    ],
    exports: [
        PessoaTermoLGPDFormComponent
    ]
})
export class PessoaTermoLGPDFormModule { }
